"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Initials = exports.ImageContainer = exports.Image = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Media = _interopRequireDefault(require("../Media"));

var containerSizes = {
  small: 'xxlarge',
  medium: 'xxxlarge',
  large: 'xxxxlarge'
};
var fontSizes = {
  small: '2rem',
  medium: '3.8rem',
  large: '4.6rem'
};
var Image = (0, _styled.default)(_Media.default)(function () {
  return {
    position: 'relative',
    width: '100%'
  };
});
exports.Image = Image;
var ImageContainer = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      avatar = _ref$theme.avatar,
      colors = _ref$theme.colors,
      space = _ref$theme.space,
      rectangular = _ref.rectangular,
      size = _ref.size;
  return _objectSpread({
    background: colors[avatar.background],
    borderRadius: rectangular ? avatar.borderRadiusRectangular : avatar.borderRadius,
    width: space[containerSizes[size]],
    height: space[containerSizes[size]],
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }, rectangular && {
    border: "".concat(avatar.borderWeight, " solid ").concat(avatar.borderColor)
  });
});
exports.ImageContainer = ImageContainer;
var Initials = (0, _styled.default)('span')(function (_ref2) {
  var size = _ref2.size,
      _ref2$theme = _ref2.theme,
      avatar = _ref2$theme.avatar,
      colors = _ref2$theme.colors;
  return _objectSpread({
    fontSize: fontSizes[size],
    color: colors[avatar.initialsColor]
  }, avatar.name.styles);
});
exports.Initials = Initials;